import React from 'react';
import { Card, Form, Row, Col } from 'react-bootstrap';

const SupplyChain = ({ formData, handleFormChange }) => {
  return (
    <Card className="dark-main-card text-light">
      <Card.Body className="p-4 compact-form">
        <h3 className="mb-4 text-white" style={{ fontSize: "1.5rem" }}>Supply Chain &amp; Materials</h3>
        <Row>
          <Col md={6}>
            <Form.Group className="mb-3" controlId="mealTypes">
              <Form.Label>Meal Types</Form.Label>
              <Form.Control
                as="select"
                multiple
                name="mealTypes"
                value={formData.mealTypes}
                onChange={handleFormChange}
                className="dark-input"
              >
                <option value="breakfast">Breakfast</option>
                <option value="lunch">Lunch</option>
                <option value="dinner">Dinner</option>
                <option value="breaks">Breaks</option>
              </Form.Control>
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group className="mb-3" controlId="dietaryRestrictions">
              <Form.Label>Dietary Restrictions</Form.Label>
              <Form.Control
                type="text"
                name="dietaryRestrictions"
                value={formData.dietaryRestrictions}
                onChange={handleFormChange}
                className="dark-input"
              />
            </Form.Group>
          </Col>
        </Row>
        <Form.Group className="mb-3" controlId="beverageRequirements">
          <Form.Label>Beverage Requirements</Form.Label>
          <Form.Control
            type="text"
            name="beverageRequirements"
            value={formData.beverageRequirements}
            onChange={handleFormChange}
            className="dark-input"
          />
        </Form.Group>
        <Form.Group className="mb-3" controlId="serviceStyle">
          <Form.Label>Service Style</Form.Label>
          <Form.Control
            as="select"
            name="serviceStyle"
            value={formData.serviceStyle}
            onChange={handleFormChange}
            className="dark-input"
          >
            <option value="buffet">Buffet</option>
            <option value="plated">Plated</option>
            <option value="stations">Stations</option>
          </Form.Control>
        </Form.Group>
      </Card.Body>
    </Card>
  );
};

export default SupplyChain;